// extracted by mini-css-extract-plugin
module.exports = {"root":"filter-property-card_root__2Fyzd","img":"filter-property-card_img__e-W_V"};